import { defineMessages } from 'react-intl';

export default defineMessages({
  feeNoteCardTitle: {
    id: 'fee_note.title',
  },
  claimNumber: {
    id: 'fee_note.claimNumber',
  },
  step: {
    id: 'fee_note.step',
  },
  creationDate: {
    id: 'fee_note.creationDate',
  },
  amountTtc: {
    id: 'fee_note.amountTtc',
  },
  amountHt: {
    id: 'fee_note.amountHt',
  },
  fee_note_number: {
    id: 'fee_note.fee_note_number',
  },
  status: {
    id: 'fee_note.status',
  },
  linesPerPage: {
    id: 'manager.documents_table.table.lines_per_page',
  },
  pending: {
    id: 'fee_note.pending',
  },
  rejected: {
    id: 'fee_note.rejected',
  },
  validated: {
    id: 'fee_note.validated',
  },
  pendingTabTitle: {
    id: 'fee_note.pending_tab_title',
  },
  rejectedTabTitle: {
    id: 'fee_note.rejected_tab_title',
  },
  validatedTabTitle: {
    id: 'fee_note.validated_tab_title',
  },
  addDialogTitle: {
    id: 'fee_note.add_dialog_title',
  },
  confirmBtn: {
    id: 'fee_note.confirm_btn',
  },
  cancelBtn: {
    id: 'cancel_btn',
  },
  saveBtn: {
    id: 'save_btn',
  },
  feeNoteDrawerTitle: {
    id: 'fee_note.drawer_title',
  },
  feeNoteLawyerDrawerTitle: {
    id: 'fee_note.drawer_lawyer_title',
  },
  feeNoteFrais: {
    id: 'fee_note.frais',
  },
  documentType: {
    id: 'fee_note.document_type',
  },
  tax: {
    id: 'fee_note.tax',
  },
  thumbnail: {
    id: 'fee_note.thumbnail',
  },
  travellingExpenses: {
    id: 'fee_note.travelling_expenses',
  },
  uploadDocumentBtn: {
    id: 'fee_note.upload_document_btn',
  },
  additionalFees: {
    id: 'fee_note.additional_fees',
  },
  exceptional: {
    id: 'fee_note.exceptional',
  },
  fileDownloaded: {
    id: 'fee_note.file_downloaded',
  },
  actionValidate: {
    id: 'fee_note.action_validate',
  },
  actionReject: {
    id: 'fee_note.action_reject',
  },
  motifLabel: {
    id: 'fee_note.motif_label',
  },
  confirmationSentence: {
    id: 'fee_note.confirmation_sentence',
  },
  validateActionDialogTitle: {
    id: 'fee_note.validate_action_dialog_title',
  },
  rejectActionDialogTitle: {
    id: 'fee_note.reject_action_dialog_title',
  },
  feeNoteRedirection: {
    id: 'fee_note.success_redirection',
  },
  pj: {
    id: 'fee_note.pj',
  },
  check: {
    id: 'fee_note.check',
  },
  pv: {
    id: 'fee_note.pv',
  },
  pvCosts: {
    id: 'fee_note.pv_costs',
  },
  judgementADD: {
    id: 'fee_note.judgement_add',
  },
  expertReport: {
    id: 'fee_note.expert_report',
  },
  judgementOnMerits: {
    id: 'fee_note.judgement_on_merits',
  },
  judgementAppeal: {
    id: 'fee_note.judgement_appeal',
  },
  invalidStep: {
    id: 'fee_note.invalid_step',
  },
  invalidType: {
    id: 'fee_note.invalid_type',
  },
  comment: {
    id: 'fee_note.comment',
  },
  feeNoteSuccess: {
    id: 'fee_note.created_success_title',
  },
  feeNoteUpdateSuccess: {
    id: 'fee_note.updated_with_costs_title',
  },
  checkLastChangeStatus: {
    id: 'fee_note.check_last_change_status',
  },
  checkNumber: {
    id: 'fee_note.check_number',
  },
  checkAmount: {
    id: 'fee_note.check_amount',
  },
  checkBank: {
    id: 'fee_note.check_bank',
  },
  checkEditionDate: {
    id: 'fee_note.check_edition_date',
  },
  successDialogPrimaryButtonTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add.success_dialog.primary_button_title',
  },
  validationSuccess: {
    id: 'fee_note.validation_confirmation_dialog.success_message',
  },
  rejectSuccess: {
    id: 'fee_note.reject_confirmation_dialog.success_message',
  },
  firmReference: {
    id: 'fee_note.firm_reference',
  },
  arretAdd: {
    id: 'fee_note.arret_add',
  },
  arretOnMerits: {
    id: 'fee_note.arret_on_merits',
  },
  motif: {
    id: 'fee_note.motif_label',
  },
  beneficiary: {
    id: 'fee_note.beneficiary',
  },
  firmReferenceWarning: {
    id: 'firm_reference_warning',
  },
  expertiseConsulting: {
    id: 'expert_expertise_concerned.consulting_expertise',
  },
  noticeDeficiency: {
    id: 'expert_expertise.tab_notice_deficiency.title',
  },
  postponementsExpertise: {
    id: 'expert_expertise.tab_postponements_expertise.title',
  },
  missionReference: {
    id: 'fee_note.mission_reference',
  },
  judgementDate: {
    id: 'fee_note.judgementDate',
  },
  courtNumber: {
    id: 'fee_note.courtNumber',
  },
  judiciaryProcess: {
    id: 'fee_note.judiciaryProcess',
  },
  appreciationExpertiseRapport: {
    id: 'expert_expertise_concerned.consulting_expertise_appreciation',
  },
  newAmount: {
    id: 'new_amount',
  },
  successDialogUpdateAmount: {
    id: 'success_dialog.update_fee_note_amount',
  },
  succesDialogUpdateStatus: {
    id: 'success_dialog.update_fee_note_status',
  },
  feeNoteDisableValidation: {
    id: 'fee_note.disable_validation_message',
  },
  feeNoteDialogChangeStatus: {
    id: 'dialog_fee_note.update_fee_note.title',
  },
  feeNoteDialogChangeDescription: {
    id: 'dialog_fee_note.update_fee_note.description',
  },
  firmReferenceInfoBloc: {
    id: 'legal_proceeding_page.firm_reference_info_bloc',
  },
  invoiceTitleData: {
    id: 'invoice.dialog_info.title',
  },
  invoiceNumber: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDate: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  receptionDate: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  invoiceDocumentTitle: {
    id: 'invoice.dialog_info.document_title',
  },
  dialogTitle: {
    id: 'dialog_fee_note.title',
  },
  inactiveTitle: {
    id: 'inactive_title',
  },
  actionChangeFirmReference: {
    id: 'fee_note.action_change_firm_reference',
  },
  dialogFirmReferenceTitle: {
    id: 'dialog_firm_reference_title.title',
  },
  lawyerFirmReferenceDialogLabel: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_label',
  },
  saveButton: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.title.judgementAdd.saveButton',
  },
  managerFirmReferenceDialogSuccessMessage: {
    id: 'legal_proceeding_page.update_firm_reference_dialog_info_success',
  },
  intervenantDialogTitle: {
    id: 'dialog_fee_note.intervenant.title',
  },
  addInvoiceTitle: {
    id: 'intervenant_actions.add_invoice.title',
  },
  rejectFeeNoteTitle: {
    id: 'intervenant_actions.reject_fee_note.title',
  },
  rejectFeeNoteDescription: {
    id: 'dialog_fee_note.reject_fee_note.description',
  },
  confirm: {
    id: 'fee_note.confirm_btn',
  },
  cancel: {
    id: 'cancel_btn',
  },
  toastSuccessRejectFeeNote: {
    id: 'fee_note.toast_succes.reject_fee_note',
  },
  invoiceNumberField: {
    id: 'invoice.dialog_info.field_invoice_number',
  },
  invoiceDateField: {
    id: 'invoice.dialog_info.field_invoice_date',
  },
  invoiceReceptionDateField: {
    id: 'invoice.dialog_info.field_invoice_reception_date',
  },
  errorInvoiceDateIntervenant: {
    id: 'invoice.dialog_info.limit_invoice_date.intervenant.error',
  },
  warningInvoiceDateManager: {
    id: 'invoice.dialog_info.limit_invoice_date.manager_warning',
  },
  invoiceTitle: {
    id: 'invoice.dialog_info.title',
  },
  warningValidationInvoiceFeeNote: {
    id: 'invoice.dialog_info.limit_invoice_date_validation.manager_warning',
  },
  kpiInvoiceDialogToTrait: {
    id: 'kpi_invoice_dialog.to_trait',
  },
  kpiInvoiceDialogTitle: {
    id: 'kpi_invoice_dialog.title',
  },
  kpiInvoiceDialogTotal: {
    id: 'kpi_invoice_dialog.total',
  },
  kpiInvoiceDialogSubTitle: {
    id: 'kpi_invoice_dialog.sub_title',
  },
  kpiInvoiceDialogInvoiceTitle: {
    id: 'kpi_invoice_dialog.invoice_title',
  },
  kpiInvoiceDialogInvoiceFooterTitle: {
    id: 'kpi_invoice_dialog.invoice_footer_title',
  },
  opening: {
    id: 'kpi_invoice_dialog.opening',
  },
  judiciary: {
    id: 'kpi_invoice_dialog.judiciary',
  },
  transaction: {
    id: 'kpi_invoice_dialog.transaction',
  },
  extractDataTitle: {
    id: 'invoice_fee_notes.extract_data.title',
  },
  notExtractedDataTitle: {
    id: 'invoice_fee_notes.not_extract_data.title',
  },
});
